var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlHorarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.167 100H100V58.3333M25 100C25 109.849 26.9399 119.602 30.709 128.701C34.4781 137.801 40.0026 146.069 46.967 153.033C53.9314 159.997 62.1993 165.522 71.2987 169.291C80.3982 173.06 90.1509 175 100 175C109.849 175 119.602 173.06 128.701 169.291C137.801 165.522 146.069 159.997 153.033 153.033C159.997 146.069 165.522 137.801 169.291 128.701C173.06 119.602 175 109.849 175 100C175 90.1509 173.06 80.3982 169.291 71.2987C165.522 62.1993 159.997 53.9314 153.033 46.967C146.069 40.0026 137.801 34.4781 128.701 30.709C119.602 26.9399 109.849 25 100 25C90.1509 25 80.3982 26.9399 71.2987 30.709C62.1993 34.4781 53.9314 40.0026 46.967 46.967C40.0026 53.9314 34.4781 62.1993 30.709 71.2987C26.9399 80.3982 25 90.1509 25 100Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlHorarios);
export default __webpack_public_path__ + "static/media/ControlHorarios.1994cb845e5ec5430470c9ae327d045a.svg";
export { ForwardRef as ReactComponent };